import React from 'react';
import { Button, Drawer, TextListItem, Typography } from '@useblu/ocean-react';
import { PaymentMethods } from '@/pages/Checkout/types/paymentLinkContextTypes';

import * as S from '../styles';
import useInstallmentsDrawer from './useInstallmentsDrawer';

interface InstallmentsDrawerProps {
  open: boolean;
  handleClose: () => void;
  type: PaymentMethods;
}

const InstallmentsDrawer = ({
  open,
  handleClose,
  type,
}: InstallmentsDrawerProps) => {
  const { handlePay, installment, installmentsOptions, setInstallment } =
    useInstallmentsDrawer(type);

  const handlePayment = async () => {
    handlePay();
    handleClose();
  }

  return (
    <Drawer open={open} overlayClose={handleClose} onDrawerClose={handleClose}>
      <S.DrawerContent>
        <Typography variant="heading3">
          Em quantas vezes você quer pagar?
        </Typography>
        <S.ListOption>
          {installmentsOptions.map(option => (
            <S.Option key={option.value}>
              <TextListItem
                title={option.title}
                description={option.description}
                radio={{
                  value: option.value,
                  name: 'installments',
                  checked: installment?.number === option.value,
                  onChange: () => setInstallment(option.installment),
                }}
              />
            </S.Option>
          ))}
        </S.ListOption>
      </S.DrawerContent>
      <S.DrawerAction>
        <Button onClick={handlePayment}>
          Pagar em {installment?.number} vezes
        </Button>
      </S.DrawerAction>
    </Drawer>
  );
};

export default InstallmentsDrawer;
